<div class="radio-container"
     [attr.data-size]="size"
     [attr.data-checked]="checked"
     [attr.data-disabled]="disabled"
     [attr.data-error]="error">
  
  <input type="radio"
         class="radio-input"
         [name]="name"
         [value]="value"
         [checked]="checked"
         [disabled]="disabled"
         [attr.aria-label]="computedAriaLabel"
         [attr.aria-required]="required"
         (change)="onSelect()"
         (focus)="onFocusEvent()"
         (blur)="onBlurEvent()" />
  
  <span class="radio-circle"></span>
</div>